import { useEffect, useRef, useState } from 'react';

import { useIsNavigatingBack } from '../context/FlowContainerContext.tsx';

/**
 * Pega briefly clears validatemessage between re-renders; debounce clearing
 * so error styling does not flicker off during a triggerFieldChange cycle.
 * Matches the debounce used in Text.tsx.
 */
export function useStableValidateMessage(message?: string): string | undefined {
  const isNavigatingBack = useIsNavigatingBack();
  const [stableMessage, setStableMessage] = useState(message);
  const clearErrorTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (isNavigatingBack) {
      clearTimeout(clearErrorTimeoutRef.current);
      setStableMessage(undefined);
      return;
    }

    if (message) {
      clearTimeout(clearErrorTimeoutRef.current);
      setStableMessage(message);
    } else {
      clearErrorTimeoutRef.current = setTimeout(() => setStableMessage(undefined), 100);
    }

    return () => clearTimeout(clearErrorTimeoutRef.current);
  }, [message, isNavigatingBack]);

  if (isNavigatingBack) {
    return undefined;
  }

  return stableMessage;
}
